module.exports = __webpack_public_path__ + "img/testimonial_1.6c3087cb.png";